import axios from "axios";

export class ServerError extends Error {
  public code: number;
  constructor(
    message: string,
    code: number,
    public serviceId: string = "service"
  ) {
    super(message);
    this.code = code;
  }

  toString() {
    return `${this.serviceId}(${this.code}): ${this.message}`;
  }
}

export default abstract class ApiModel {
  abstract basePath: string;
  addDefaultHeaders(headers: any) {
    return {
      ...headers,
    };
  }

  abstract handleErrorResponse(response: any): Error;
  abstract handleErrorRequest(request: any): Error;

  async get(url: string, params?: object, headers?: any) {
    try {
      headers = this.addDefaultHeaders(headers);
      return await axios.get(this.basePath + url, {
        headers: headers,
        params: params,
      });
    } catch (e) {
      if (e.response) {
        throw this.handleErrorResponse(e.response);
      } else if (e.request) {
        throw this.handleErrorRequest(e.request);
      } else {
        throw new Error("Bad implementation");
      }
    }
  }

  async put(url: string, body: any, params?: object, headers?: any) {
    try {
      headers = this.addDefaultHeaders(headers);
      return await axios.put(this.basePath + url, body, {
        headers: headers,
        params: params,
      });
    } catch (e) {
      if (e.response) {
        throw this.handleErrorResponse(e.response);
      } else if (e.request) {
        throw this.handleErrorRequest(e.request);
      } else {
        throw new Error("Bad implementation");
      }
    }
  }

  async post(url: string, body: any, params?: object, headers?: any) {
    try {
      headers = this.addDefaultHeaders(headers);
      return await axios.post(this.basePath + url, body, {
        headers: headers,
        params: params,
        timeout: 300000,
      });
    } catch (e) {
      if (e.response) {
        throw this.handleErrorResponse(e.response);
      } else if (e.request) {
        throw this.handleErrorRequest(e);
      } else {
        throw new Error("Bad implementation");
      }
    }
  }

  async delete(url: string, body?: object, params?: object, headers?: any) {
    try {
      headers = this.addDefaultHeaders(headers);
      return await axios.delete(this.basePath + url, {
        headers: headers,
        params: params,
        data: body,
      });
    } catch (e) {
      if (e.response) {
        throw this.handleErrorResponse(e.response);
      } else if (e.request) {
        throw this.handleErrorRequest(e.request);
      } else {
        throw new Error("Bad implementation");
      }
    }
  }
}
